import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = {
  key: 1,
  class: "row g-3 needs-validation form"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "position-relative" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = { class: "col-lg-4" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = { class: "col-lg-4" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "position-relative" }
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "position-relative" }
const _hoisted_31 = { class: "col-lg-4" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = { class: "col-lg-4" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "col-lg-4" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "col-lg-4" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "col-lg-4" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4 mt-4"
}
const _hoisted_47 = { class: "card-body p-4" }
const _hoisted_48 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-4"
}
const _hoisted_49 = { class: "submit-button" }
const _hoisted_50 = {
  key: 2,
  type: "button",
  class: "btn btn-info ms-3 text-white"
}
const _hoisted_51 = {
  key: 3,
  type: "button",
  class: "btn btn-success ms-3 text-white"
}
const _hoisted_52 = { class: "submit-button" }
const _hoisted_53 = { class: "table mt-3" }
const _hoisted_54 = { class: "table" }
const _hoisted_55 = {
  key: 0,
  scope: "col"
}
const _hoisted_56 = { scope: "row" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "d-flex justify-content-around" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  class: "modal fade",
  id: "modalItem",
  tabindex: "-1",
  "aria-labelledby": "modalItemLabel",
  "aria-hidden": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_62 = { class: "modal-dialog" }
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-body" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-lg-12" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { class: "col-lg-6" }
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = { class: "position-relative" }
const _hoisted_75 = { class: "col-lg-6" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = { class: "position-relative" }
const _hoisted_78 = { class: "col-lg-12" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = { class: "position-relative" }
const _hoisted_81 = { class: "col-lg-12" }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = { class: "position-relative" }

import { onMounted, onUnmounted, ref, toRaw, watch } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { formatDate, mapOptionMultiselect } from "@/utils/helper";
import { toast } from "vue-sonner";
import { db } from "@/database/db";
import {
  RequisitionResponse,
  RequisitionUpdateStatus,
  VariantInterface,
} from "@/types/interface/requisition";
import { useRequisitionStore } from "@/stores/management/requisition";
import Swal from "sweetalert2";
import { useItemStore } from "@/stores/management/item";
import { useVesselItemStore } from "@/stores/management/item-vessel";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useCategoryStore } from "@/stores/master/category-store";
import isOnline from "is-online";
import { useRequisitionItemStore } from "@/stores/management/requisition-item";
import vSelect from "vue-select";

interface CheckExisting {
  existance: boolean;
  data: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailRequisition',
  setup(__props) {

const idRequisition = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const requisitionStore = useRequisitionStore();
const listItemDixie = ref<any>([]);
const modalShow = ref<any>(false);
const showProductForm = ref(false);
const requisitionDetail = ref<RequisitionResponse>();
const requisitionId = ref<number>();
let modalInstance: any;
const isRevision = ref(false);
const isEditProduct = ref(false);
const itemStore = useItemStore();
const listItem = ref<any>([]);
const queryTemp = ref<any>("");
const itemTemp = ref<any>();
const qtyTemp = ref<any>();
const est_rob = ref(0);
const remark = ref("");
const haveVarian = ref(false);
const variant = ref<VariantInterface>();
const vesselItemStore = useVesselItemStore();
const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const requisitionItemStore = useRequisitionItemStore();

const category = ref("");
const categoryVal = ref("");
const group_category = ref("");
const group_categoryVal = ref("");
const port = ref("");
const date = ref("");
const msg_id = ref("");
const vessel = ref("");
const pic_onboard = ref("");
const form_no = ref("");
const ref_no = ref("");
const userLogin = ref({});
const remarkReq = ref("");
const priority = ref("");
const req_status = ref("");
const listVariant = ref([]);
const vessel_id = ref("");
const rob = ref(0);
const maxQuantity = ref("");

const emptyStateModal = () => {
  modalShow.value = false;
  qtyTemp.value = "";
  itemTemp.value = "";
  remark.value = "";
  variant.value = { value: null, label: null };
  rob.value = 0;
  est_rob.value = 0;
  isEditProduct.value = false;
  haveVarian.value = false;
};

const buildQuery = async (search = "") => {
  queryTemp.value = "";
  if (categoryVal.value != undefined) {
    const { success } = await categoryStore.dispatchDetail(
      categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value + "&category_code=" + categoryStore.category.data.code;
    }
  }

  if (group_categoryVal.value != undefined) {
    const { success } = await groupCategoryStore.dispatchDetail(
      group_categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value +
        "&group_category_code=" +
        groupCategoryStore.categoryGroup.data.code;
      msg_id.value = groupCategoryStore.categoryGroup.data.code;
    }
  }

  if (search != undefined) {
    queryTemp.value = queryTemp.value + "&keyword=" + search;
  }

  loadDataItem();
};

const chooseVariant = async () => {
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
};

const chooseItem = async () => {
  let detailProduct = await loadDetailProduct(itemTemp.value?.value);
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
  if (detailProduct?.variant.length > 0) {
    haveVarian.value = true;
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
  } else {
    haveVarian.value = false;
    listVariant.value = [];
  }
};

let debounceTimeoutItem: any;
const handleSearch = (query: string) => {
  clearTimeout(debounceTimeoutItem);
  debounceTimeoutItem = setTimeout(() => {
    buildQuery(query);
  }, 500);
};

const loadProductFromDixie = async () => {
  const products = await db.product
    .where({ requisition_id: requisitionId.value })
    .toArray();
  listItemDixie.value = products;
};

const addProductToDixie = async (item: any) => {
  item.forEach(async (element) => {
    await db.product.put({
      requisition_id: requisitionId.value,
      id_product: element?.item_id,
      data: toRaw(element),
      qty: element.qty_required,
      remark: element.remark,
      id_variant: element.variant_id,
      variant: toRaw({
        value: element.variant_id,
        label: element.variant_key + "-" + element.variant_value,
      }),
      rob: element.rob,
    });
  });
};

const loadRequisition = async () => {
  const { success, message } = await requisitionStore.dispatchDetail(
    idRequisition.value
  );
  if (success) {
    requisitionDetail.value = requisitionStore?.requisition?.data;
    category.value =
      requisitionDetail.value.category.code +
      " - " +
      requisitionDetail.value.category.name;
    group_category.value =
      requisitionDetail.value.groupCategory.code +
      " (" +
      requisitionDetail.value.groupCategory.name +
      ")";
    port.value =
      requisitionDetail.value.port.name +
      " - " +
      requisitionDetail.value.port.country;
    categoryVal.value = requisitionDetail.value.category;
    group_categoryVal.value = requisitionDetail.value.groupCategory;
    date.value = formatDate(requisitionDetail.value.created_at);
    msg_id.value = requisitionDetail.value?.groupCategory?.code;
    pic_onboard.value = requisitionDetail.value?.pic_onboard;
    form_no.value = requisitionDetail.value?.form_no;
    ref_no.value = requisitionDetail.value?.ref_no;
    requisitionId.value = requisitionDetail.value.id;
    priority.value = requisitionDetail.value.priority;
    req_status.value = requisitionDetail.value.requisition_status?.name;
    remarkReq.value = requisitionDetail.value.remarks;
    showProductForm.value = true;
    // listItemDixie.value = requisitionDetail.value?.requisitionItem;
    buildQuery();
    // if (requisitionDetail.value?.requisitionItem.length > 0) {
    //   addProductToDixie(requisitionDetail.value.requisitionItem);
    // }
    loadProductFromDixie();
  }
};

const loadUserLogin = async () => {
  let getDataLogin = await db.storage.get("login-info");
  userLogin.value = getDataLogin?.data;
  vessel.value = `${userLogin.value?.vessel?.name} (${userLogin.value?.vessel?.call_sign})`;
};

const doUpdateRequisitionStatus = async (status: number) => {
  if (status == 5) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        cancelButton: "btn btn-danger",
        confirmButton: "btn btn-success",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `Are you sure you want to decline requisition ?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        input: "text",
        inputPlaceholder: "Enter reason for decline",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        cancelButtonText: "No!",
        reverseButtons: true,
        preConfirm: (reason) => {
          if (!reason) {
            Swal.showValidationMessage("Reason is required!");
          }
          return reason;
        },
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const reason = result.value;
          let payload: RequisitionUpdateStatus = {
            requisition_status_id: status,
            revision_note: "",
            decline_note: reason,
          };
          const { success, message } =
            await requisitionStore.dispatchUpdateStatus(
              idRequisition.value,
              payload
            );

          if (success) {
            router.push("/management/requisition");
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Your action has been aborted",
            icon: "error",
          });
        }
      });
  } else {
    let payload: RequisitionUpdateStatus = {
      requisition_status_id: status,
      revision_note: "",
      decline_note: "",
    };
    const { success, message } = await requisitionStore.dispatchUpdateStatus(
      idRequisition.value,
      payload
    );

    if (success) {
      router.push("/management/requisition");
    }
  }
};

onMounted(() => {
  setTimeout(() => {
    const modalEl = document.getElementById("modalItem");
    if (modalEl) {
      const bootstrap = (window as any).bootstrap;
      modalInstance = new bootstrap.Modal(modalEl);
    }
  }, 1000);
  loadUserLogin();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idRequisition.value = router.currentRoute.value.params.id.toString();
    loadRequisition();
  }
});

const backToListRequisition = () => {
  handleBeforeReloadModal("/management/requisition");
};

const handleBeforeReloadModal = (to: any) => {
  Swal.fire({
    title: "Are you sure want to leave requisition page ?",
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: "Yes",
    denyButtonText: `No`,
    text: "All data will deleted, unless you already save before",
  }).then((result) => {
    if (result.isConfirmed) {
      router.push(to);
    }
  });
};

const setRevisionMode = (state: boolean) => {
  isRevision.value = state;
};

const loadDataItem = async () => {
  const { success, message } = await itemStore.dispatchGetCatalogs(
    1,
    99,
    queryTemp.value
  );
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items?.items,
      "id",
      "name"
    );
  }
};

const loadDetailProduct = async (id: string) => {
  const { success } = await itemStore.dispatchDetail(id);
  if (success) {
    return itemStore.item?.data;
  }
};

const loadSpecificDetail = async (id: string) => {
  let queryParams = "?vessel_id=" + vessel_id.value + "&goods_id=" + id;
  if (haveVarian.value) {
    queryParams = queryParams + "&variant_id=" + variant.value?.value;
  }
  const { success } = await vesselItemStore.dispatchSpecificDetail(queryParams);
  if (success) {
    rob.value = vesselItemStore.vesselItem?.data?.rob;
    maxQuantity.value = vesselItemStore.vesselItem?.data?.quantity;
    return vesselItemStore.vesselItem?.data;
  }
};

const existingProduct = async (
  idProduct: number,
  idVariant: number
): Promise<CheckExisting> => {
  let existing = null;
  if (haveVarian.value) {
    existing = await db.product
      .where({
        id_product: idProduct,
        id_variant: idVariant,
        requisition_id: requisitionId.value,
      })
      .first();
    if (!existing && isEditProduct.value == true) {
      existing = await db.product
        .where({ id_product: idProduct, requisition_id: requisitionId.value })
        .first();
    }
  } else {
    existing = await db.product
      .where({ id_product: idProduct, requisition_id: requisitionId.value })
      .first();
  }
  return {
    existance: !!existing,
    data: existing,
  };
};

const addItemDixie = async () => {
  let error = 0;
  let errMessage = "";
  if (itemTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Item can not empty";
  }

  if (qtyTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Qty Required can not empty";
  }

  if (remark.value == "" && error == 0) {
    error = 1;
    errMessage = "Remark can not empty";
  }

  const loadProductFromDixie = async () => {
    const products = await db.product
      .where({ requisition_id: requisitionId.value })
      .toArray();
    listItemDixie.value = products;
  };

  if (await isOnline()) {
    const variantExist = variant.value?.value ? variant.value?.value : null;
    const responseCheck = await requisitionItemStore.dispatchCheckExistingRequest(Number(vessel_id.value), itemTemp.value?.value, variantExist);

    if (responseCheck.data) {
      Swal.fire({
        title: "The item is already requested.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        denyButtonText: `No`,
        text: responseCheck.message,
      }).then(async (result) => {
        if (result.isConfirmed) {

          if (error == 0) {
            if (qtyTemp.value + rob.value <= maxQuantity.value) {
              let detailProduct = await loadDetailProduct(itemTemp.value?.value);
              let resultExisiting = await existingProduct(
                itemTemp.value?.value,
                variant.value?.value
              );
              if (isEditProduct.value) {
                await db.product.update(resultExisiting.data.id, {
                  qty:
                    isEditProduct.value == true
                      ? qtyTemp.value
                      : qtyTemp.value + resultExisiting.data.qty,
                  variant: toRaw(variant.value),
                  rob: rob.value,
                  est_rob: est_rob.value,
                  remark: remark.value,
                });
                toast.success("Item successfully updated");
              } else {
                if (!resultExisiting.existance) {
                  await db.product.put({
                    requisition_id: requisitionId.value,
                    id_product: detailProduct?.id,
                    data: toRaw(detailProduct),
                    qty: qtyTemp.value,
                    id_variant: variant.value?.value,
                    variant: toRaw(variant.value),
                    remark: remark.value,
                    rob: rob.value,
                    est_rob: est_rob.value,
                  });
                  toast.success("Item successfully added");
                } else {
                  await db.product.update(resultExisiting.data.id, {
                    qty:
                      isEditProduct.value == true
                        ? qtyTemp.value
                        : qtyTemp.value + resultExisiting.data.qty,
                    variant: toRaw(variant.value),
                    rob: rob.value,
                    est_rob: est_rob.value,
                    remark: remark.value,
                  });
                  toast.success("Item successfully updated");
                }
              }
              emptyStateModal();
              loadProductFromDixie();
            } else {
              toast.error(
                `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
              );
            }
          } else {
            toast.error(errMessage);
          }
          
        }
      });
    } else {
      if (qtyTemp.value + rob.value <= maxQuantity.value) {
        let detailProduct = await loadDetailProduct(itemTemp.value?.value);
        let resultExisiting = await existingProduct(
          itemTemp.value?.value,
          variant.value?.value
        );
        if (isEditProduct.value) {
          await db.product.update(resultExisiting.data.id, {
            qty:
              isEditProduct.value == true
                ? qtyTemp.value
                : qtyTemp.value + resultExisiting.data.qty,
            variant: toRaw(variant.value),
            rob: rob.value,
            est_rob: est_rob.value,
            remark: remark.value,
          });
          toast.success("Item successfully updated");
        } else {
          if (!resultExisiting.existance) {
            await db.product.put({
              requisition_id: requisitionId.value,
              id_product: detailProduct?.id,
              data: toRaw(detailProduct),
              qty: qtyTemp.value,
              id_variant: variant.value?.value,
              variant: toRaw(variant.value),
              remark: remark.value,
              rob: rob.value,
              est_rob: est_rob.value,
            });
            toast.success("Item successfully added");
          } else {
            await db.product.update(resultExisiting.data.id, {
              qty:
                isEditProduct.value == true
                  ? qtyTemp.value
                  : qtyTemp.value + resultExisiting.data.qty,
              variant: toRaw(variant.value),
              rob: rob.value,
              est_rob: est_rob.value,
              remark: remark.value,
            });
            toast.success("Item successfully updated");
          }
        }
        emptyStateModal();
        loadProductFromDixie();
      } else {
        toast.error(
          `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
        );
      }
    } 

    return;
  } else {
    const param = {
      requisition_id: requisitionId.value,
      id_product: itemTemp.value?.value,
    };
    
    if (variant.value?.value) param.id_variant = variant.value?.value;

    let resultExisiting = db.product.get(param);

    if (resultExisiting?.id) {
      await db.product.update(resultExisiting.id, {
        qty:
          isEditProduct.value == true
            ? qtyTemp.value
            : qtyTemp.value + resultExisiting.qty,
        variant: toRaw(variant.value),
        rob: rob.value,
        est_rob: est_rob.value,
        remark: remark.value,
      });
      toast.success("Item successfully updated");
    } else {
      await db.product.put({
        requisition_id: requisitionId.value,
        id_product: itemTemp.value?.value,
        // data: toRaw(resultExisiting),
        qty: qtyTemp.value,
        id_variant: variant.value?.value,
        // variant: toRaw(variant.value),
        remark: remark.value,
        rob: rob.value,
        est_rob: est_rob.value,
      });
      toast.success("Item successfully added");
    }

    emptyStateModal();
    loadProductFromDixie();
    return;
  }

};

const handleEditProduct = async (id: number) => {
  isEditProduct.value = true;
  loadDataItem();
  modalShow.value = true;
  let getDataTemp = await db.product.get(id);
  if (getDataTemp?.data?.item_name === undefined) {
    itemTemp.value = mapOptionMultiselect(
      getDataTemp?.data,
      "item_id", 
      "item_name"
    );
  } else {
    itemTemp.value = mapOptionMultiselect(getDataTemp?.data, "id", "item_name");
  }
  console.log('data temp => ',getDataTemp);
  qtyTemp.value = getDataTemp?.qty;
  est_rob.value = getDataTemp?.data?.rob_estimate;
  remark.value = getDataTemp?.data?.remarks;
  let detailProduct = await loadDetailProduct(getDataTemp?.id_product);
  if (getDataTemp?.variant?.value != undefined) {
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
    haveVarian.value = true;
    variant.value = getDataTemp?.variant;
  } else {
    haveVarian.value = false;
  }
  let specificDetail = await loadSpecificDetail(getDataTemp?.id_product);
};

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
              _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "mb-0" }, "Form Create Requisition", -1)),
              _createElementVNode("a", {
                class: "btn btn-danger fw-semibold text-white px-3",
                type: "button",
                onClick: backToListRequisition
              }, _cache[22] || (_cache[22] = [
                _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }, null, -1),
                _createTextVNode(" Back To List Requisition ")
              ]))
            ]),
            (isLoading.value)
              ? (_openBlock(), _createBlock(BaseLoading, {
                  key: 0,
                  text: "Processing Data..."
                }))
              : _createCommentVNode("", true),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          for: "form_no",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Form No "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            name: "form_no",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form_no).value = $event)),
                            placeholder: "Form No",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, form_no.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                          for: "ref_no",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Ref No "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            name: "ref_no",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ref_no).value = $event)),
                            placeholder: "Ref No",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, ref_no.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", {
                          for: "vessel",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Vessel "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            name: "vessel",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vessel).value = $event)),
                            placeholder: "Vessel",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, vessel.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", {
                          for: "port",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Port "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              name: "port",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((port).value = $event)),
                              placeholder: "Port",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, port.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", {
                          for: "date",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Date Receipt "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            name: "date",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((date).value = $event)),
                            placeholder: "Date Receipt",
                            type: "date",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, date.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", {
                          for: "category",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Category "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _withDirectives(_createElementVNode("input", {
                              name: "category",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((category).value = $event)),
                              placeholder: "category",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, category.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", {
                          for: "group_category",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Group Category "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              name: "group_category",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((group_category).value = $event)),
                              placeholder: "group_category",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, group_category.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", {
                          for: "msg_id",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("MSG ID "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_33, [
                          _withDirectives(_createElementVNode("input", {
                            name: "msg_id",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((msg_id).value = $event)),
                            placeholder: "MSG ID",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, msg_id.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[32] || (_cache[32] = _createElementVNode("label", {
                          for: "pic",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("PIC Onboard "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_36, [
                          _withDirectives(_createElementVNode("input", {
                            name: "pic",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((pic_onboard).value = $event)),
                            placeholder: "PIC Onboard",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, pic_onboard.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", {
                          for: "priority",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Priority "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_39, [
                          _withDirectives(_createElementVNode("input", {
                            name: "priority",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((priority).value = $event)),
                            placeholder: "Priority",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, priority.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                          for: "req_status",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Requisition Status "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            name: "req_status",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((req_status).value = $event)),
                            placeholder: "Requisition Status",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, req_status.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", {
                          for: "remarkReq",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Remark "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("textarea", {
                            name: "remarkReq",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((remarkReq).value = $event)),
                            placeholder: "Requisition Remark",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, remarkReq.value]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (showProductForm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                (requisitionDetail.value.approval_job_id == userLogin.value.job.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (!isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-success ms-3 text-white",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (doUpdateRequisitionStatus(3)))
                            }, " Approved "))
                          : _createCommentVNode("", true),
                        (!isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-danger ms-3 text-white",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (doUpdateRequisitionStatus(5)))
                            }, " Decline "))
                          : _createCommentVNode("", true),
                        (isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_50, " Add Item "))
                          : _createCommentVNode("", true),
                        (isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_51, " Submit Requisition "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        (!isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-warning ms-3 text-white",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (setRevisionMode(true)))
                            }, " Revision "))
                          : _createCommentVNode("", true),
                        (isRevision.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-danger ms-3 text-white",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (setRevisionMode(false)))
                            }, " Cancel Revision "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("table", _hoisted_54, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[36] || (_cache[36] = _createElementVNode("th", { scope: "col" }, "No", -1)),
                        _cache[37] || (_cache[37] = _createElementVNode("th", { scope: "col" }, "Item Description", -1)),
                        _cache[38] || (_cache[38] = _createElementVNode("th", { scope: "col" }, "Qty Required", -1)),
                        _cache[39] || (_cache[39] = _createElementVNode("th", { scope: "col" }, "Unit", -1)),
                        _cache[40] || (_cache[40] = _createElementVNode("th", { scope: "col" }, "ROB", -1)),
                        _cache[41] || (_cache[41] = _createElementVNode("th", { scope: "col" }, "IMPA", -1)),
                        _cache[42] || (_cache[42] = _createElementVNode("th", { scope: "col" }, "MSG CODE", -1)),
                        (isRevision.value)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_55, "ACTION"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItemDixie.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index + 1
                        }, [
                          _createElementVNode("th", _hoisted_56, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item?.data?.name ?? item?.data?.item_name) + " ", 1),
                            (item.variant?.value != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "- " + _toDisplayString(item?.variant?.label), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.qty_required), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.unit), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.rob_estimate), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.impa_code), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.msg_code), 1),
                          (isRevision.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-success text-white btn-edit",
                                    onClick: ($event: any) => (handleEditProduct(item?.id))
                                  }, " Edit ", 8, _hoisted_60),
                                  _cache[43] || (_cache[43] = _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-danger btn-delete"
                                  }, " Delete ", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[44] || (_cache[44] = _createElementVNode("h5", {
              class: "modal-title",
              id: "modalItemLabel"
            }, "Modal Form Add Item", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: emptyStateModal
            })
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", {
                    for: "item",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Item "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_unref(vSelect), {
                      modelValue: itemTemp.value,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((itemTemp).value = $event)),
                      options: listItem.value,
                      placeholder: "Choose Item",
                      onSearch: handleSearch,
                      onClose: chooseItem
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              (haveVarian.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", {
                        for: "varian",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Varian "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_unref(vSelect), {
                          modelValue: variant.value,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((variant).value = $event)),
                          options: listVariant.value,
                          placeholder: "Choose Varian Item",
                          onClose: chooseVariant
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", {
                    for: "rob",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Rob "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_74, [
                    _withDirectives(_createElementVNode("input", {
                      name: "rob",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((rob).value = $event)),
                      placeholder: "Remaining Quantity",
                      type: "number",
                      class: "form-control text-dark",
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, rob.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _cache[48] || (_cache[48] = _createElementVNode("label", {
                    for: "est_rob",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Estimate ROB "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_77, [
                    _withDirectives(_createElementVNode("input", {
                      name: "est_rob",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((est_rob).value = $event)),
                      placeholder: "Est Remaining Quantity",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, est_rob.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _cache[49] || (_cache[49] = _createElementVNode("label", {
                    for: "qty",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Qty "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_80, [
                    _withDirectives(_createElementVNode("input", {
                      name: "qty",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((qtyTemp).value = $event)),
                      placeholder: "Qty Required",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, qtyTemp.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _cache[50] || (_cache[50] = _createElementVNode("label", {
                    for: "remark",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Remark "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_83, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "remark",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((remark).value = $event)),
                      placeholder: "Remark",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, remark.value]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: emptyStateModal
            }, " Close "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: addItemDixie
            }, " Add ")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})